<div class="custom-width h-100 d-flex flex-column justify-content-start align-items-start">
  <!-- <h3 class="mb-0">Dashboard</h3>
  <mat-list role="list">
    <mat-list-item (click)="clickOnVoiceButton()" role="listitem">Item 1</mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item (click)="clickOnVoiceButton()" role="listitem">Item 2</mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item (click)="clickOnVoiceButton()" role="listitem">Item 3</mat-list-item>
  </mat-list> -->
  @if (organizationId) {

  <!-- <mat-list role="list">
    <mat-list-item (click)="clickOnVoiceButton()" role="listitem">
      <a [routerLink]="['/', organizationId, 'dashboard']">Dashboard </a>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item (click)="clickOnVoiceButton()" role="listitem">
      <a [routerLink]="['/', organizationId, 'invoices_table']">Invoices </a>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item (click)="clickOnVoiceButton()" role="listitem">
      <a [routerLink]="['/', organizationId, 'company_table']">Customers </a>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item (click)="clickOnVoiceButton()" role="listitem">
      <a [routerLink]="['/', organizationId, 'fiscal_plan']">Fiscal Plan </a>
    </mat-list-item>
    <mat-divider></mat-divider>
  </mat-list> -->

  <!-- <div class="d-flex justify-content-left w-100">
    <span class="spacer"></span>
    <b>IzyFisco</b>
  </div> -->

  <mat-accordion class="w-100 me-1">

    <mat-nav-list class="x-y-transform mt-0 mb-0">
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'dashboard']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">
          dashboard
        </mat-icon>
        <span matLine>Dashboard</span>
      </a>
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'bacheca']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">
          calendar_month
        </mat-icon>
        <span matLine>Bacheca</span>
      </a>
    </mat-nav-list>

    <mat-divider class="me-3 ms-3"></mat-divider>

    <!-- <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="material-symbols-outlined me-2" aria-hidden="true">
            home
          </mat-icon>
          <span matLine>Home</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-nav-list>
        <a
          mat-list-item
          [routerLink]="['/', organizationId, 'dashboard']"
          class="menu-link"
          (click)="clickOnVoiceButton()"
        >
          <mat-icon class="material-symbols-outlined" aria-hidden="true">
            space_dashboard
          </mat-icon>
          <span matLine>Dashboard</span>
        </a>
      </mat-nav-list>
    </mat-expansion-panel> -->

    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="material-symbols-outlined me-2" aria-hidden="true">
            payments
          </mat-icon>
          <span matLine>Fatturazione</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-list role="list">
        <mat-nav-list>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'new_invoice']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              note_add
            </mat-icon>
            <span matLine>Nuova fattura</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'invoices_table']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              payments
            </mat-icon>
            <span matLine>Fatture inviate</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'drafts_table']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              drafts
            </mat-icon>
            <span matLine>Bozze salvate</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'new_invoice']"
            [queryParams]="{ documentType: 'TD04' }"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              assignment_return
            </mat-icon>
            <span matLine>Nota di credito</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'preventives_table']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material" aria-hidden="true">
              content_paste_go
            </mat-icon>
            <span matLine>Preventivi</span>
          </a>
          <!-- <a
            mat-list-item
            [routerLink]="['/', organizationId, 'new_invoice']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              receipt_long
            </mat-icon>
            <span matLine>Nuova fattura (passiva)</span>
          </a> -->

          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'upload_xml']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              upload_file
            </mat-icon>
            <span matLine>Carica fattura XML</span>
          </a>

          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'corrispettivi-receipts']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              point_of_sale
            </mat-icon>
            <span matLine>Corrispettivi</span>
          </a>

        </mat-nav-list>
      </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="material-symbols-outlined me-2" aria-hidden="true">
            groups
          </mat-icon>
          <span matLine>Clienti</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-list role="list">
        <mat-nav-list>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'company_table']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              groups
            </mat-icon>
            <span matLine>Lista clienti</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'new_company']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              person_add
            </mat-icon>
            <span matLine>Nuovo cliente</span>
          </a>
          <!-- <a
            mat-list-item
            [routerLink]="['/', organizationId, 'upload_company_list_from_excel']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              person_add
            </mat-icon>
            <span matLine>Importa clienti</span>
          </a> -->
        </mat-nav-list>
      </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="material-symbols-outlined me-2" aria-hidden="true">
            inventory
          </mat-icon>
          <span matLine>Prodotti e servizi</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-list role="list">
        <mat-nav-list>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'savedproducts_table']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              bookmark_added
            </mat-icon>
            <span matLine>Lista salvati</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'new_savedproduct']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              add
            </mat-icon>
            <span matLine>Nuovo prodotto o servizio</span>
          </a>
        </mat-nav-list>
      </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="material-symbols-outlined me-2" aria-hidden="true">
            punch_clock
          </mat-icon>
          <span matLine>Area Fiscale</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-list role="list">
        <mat-nav-list>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'fiscal_plan']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              event_note
            </mat-icon>
            <span matLine>Piano fiscale</span>
          </a>
          <a
            *ngIf="organization_data && organization_data.is_only_invoicing == false"
            mat-list-item
            [routerLink]="['/', organizationId, 'dichiarazione']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              description
            </mat-icon>
            <span matLine>Dichiarazione redditi</span>
          </a>
        </mat-nav-list>
      </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="material-symbols-outlined me-2" aria-hidden="true">
            account_box
          </mat-icon>
          <span matLine>Profilo</span>
          <!-- <span *ngIf="organization_data && organization_data.source === 'BEIZY' && organization_data.is_only_invoicing == false" class="ms-3 message-chip">
            Nuovo
          </span> -->
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-list role="list">
        <mat-nav-list>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'profile']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              account_box
            </mat-icon>
            <span matLine>Profilo</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'documents_table']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              library_books
            </mat-icon>
            <span matLine>Documenti</span>
          </a>
          <!-- "Porta un amico" nascosto per ora: per riattivarlo togliere il
               commento qui e la voce corrispondente in global-search/search-catalog.ts -->
          <!-- <a
          *ngIf="organization_data && organization_data.source === 'BEIZY' && organization_data.is_only_invoicing == false"
            mat-list-item
            [routerLink]="['/', organizationId, 'referral']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              accessibility_new
            </mat-icon>
            <span matLine>Porta un amico</span>
            <span>
              <mat-icon class="ms-2 material-symbols-outlined" aria-hidden="true">
                star_shine
              </mat-icon>
            </span>
          </a> -->
        </mat-nav-list>
      </mat-list>
    </mat-expansion-panel>

    <!-- <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="material-symbols-outlined me-2" aria-hidden="true">
            corporate_fare
          </mat-icon>
          <span matLine>Area personale</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-list role="list">
        <mat-nav-list>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'profile']"
            class="menu-link white_list"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              account_circle
            </mat-icon>
            <span matLine>Profilo</span>
          </a>
          <a
            mat-list-item
            [routerLink]="['/', organizationId, 'dichiarazione']"
            class="menu-link"
            (click)="clickOnVoiceButton()"
          >
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              account_circle
            </mat-icon>
            <span matLine>My organization</span>
          </a>
        </mat-nav-list>
      </mat-list>
    </mat-expansion-panel> -->

    <!-- <mat-divider class="me-3 ms-3"></mat-divider> -->

    <!-- <mat-nav-list class="x-y-transform">
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'upload_xml']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">
          upload_file
        </mat-icon>
        <span matLine>Carica XML</span>
      </a>
    </mat-nav-list> -->

    <!-- <mat-divider class="me-3 ms-3"></mat-divider> -->

    <!-- <mat-nav-list class="x-y-transform">
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'documents_table']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">
          library_books
        </mat-icon>
        <span matLine>Documenti</span>
      </a>
    </mat-nav-list> -->

    <mat-divider
      *ngIf="organization_data && organization_data.is_only_invoicing == false && organization_data.source === 'BEIZY'"
      class="me-3 ms-3"></mat-divider>

    <mat-nav-list 
      *ngIf="organization_data && organization_data.is_only_invoicing == false && organization_data.source === 'BEIZY'"
      class="x-y-transform">
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'commercialista-tickets']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon
          class="material-symbols-outlined custom-badge-yellow"
          aria-hidden="true"
          [matBadge]="ticketsNumber"
          [matBadgeHidden]="!ticketsNumber || ticketsNumber === 0"
          >
          chat_bubble
        </mat-icon>
        <span matLine>Il tuo Commercialista</span>
        <!-- <span *ngIf="ticketsNumber > 0" class="ms-3 message-chip">
          {{ ticketsNumber || 0 }}
        </span> -->
      </a>
    </mat-nav-list>

    <mat-divider class="me-3 ms-3"></mat-divider>

    <mat-nav-list class="x-y-transform">
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'inbox']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon
          class="material-symbols-outlined custom-badge-blue"
          aria-hidden="true"
          [matBadge]="messagesNumber"
          [matBadgeHidden]="!messagesNumber || messagesNumber === 0"
          >
          mail
        </mat-icon>
        <span matLine>Notifiche e avvisi</span>
        <!-- <span *ngIf="messagesNumber > 0" class="ms-3 message-chip">
          {{ messagesNumber || 0 }}
        </span> -->
      </a>
    </mat-nav-list>

    <mat-divider class="me-3 ms-3"></mat-divider>

    <mat-nav-list class="x-y-transform">
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'guides']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">
          help_outline
        </mat-icon>
        <span matLine>Guide e tutorial</span>
      </a>
    </mat-nav-list>

    <!-- <mat-divider class="me-3 ms-3"></mat-divider> -->

    <!-- <mat-nav-list class="x-y-transform">
      <a
        mat-list-item
        [routerLink]="['/', organizationId, 'profile']"
        class="menu-link"
        (click)="clickOnVoiceButton()"
      >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">
          account_box
        </mat-icon>
        <span matLine>Profilo</span>
      </a>
    </mat-nav-list> -->

  </mat-accordion>

  <!-- <mat-accordion class="w-100">
    <mat-expansion-panel [expanded]="false" [hideToggle]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-nav-list>
            <a
              mat-list-item
              [routerLink]="['/', organizationId, 'dichiarazione']"
              class="menu-link"
            >
              <mat-icon class="material-symbols-outlined" aria-hidden="true">
                account_circle
              </mat-icon>
              <span matLine>Profile</span>
            </a>
          </mat-nav-list>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </mat-accordion> -->

  <mat-divider></mat-divider>
  } @if (auth.user | async; as user) {
  <!-- <div
    class="d-flex justify-content-start align-items-center mt-auto mb-2 align-self-stretch"
  >
    <div
      style="
      display: inline-block;
      width: 2rem;
      height: 2rem;
      border-radius: 20%;
      background-image: url('{{ user.photoURL }}');
      background-size: cover;
      background-position: center;
    "
    ></div>
    <div class="ps-2">
      <small class="d-block">
        {{ user.displayName }}
      </small>
    </div>

    <div class="px-2 ms-auto">
      <div class="d-inline-flex align-items-center justify-content-center">
        <small class="d-block italic" [routerLink]="['/', organizationId, 'companies']" (click)="clickOnVoiceButton()">
            <mat-icon>cached</mat-icon>
        </small>
        <small class="d-block italic" [routerLink]="['/', 'auth', 'logout']" (click)="clickOnVoiceButton()">
            <mat-icon>logout</mat-icon>
        </small>
      </div>
    </div>
  </div> -->

  <div
    class="side-user-card izy-sharp-bl align-items-center mt-auto mb-2 align-self-stretch"
  >
    <!-- First row - image and username side by side -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex align-items-center gap-2">
          <div
            class="flex-shrink-0"
            style="
              width: 2rem;
              height: 2rem;
              border-radius: 20%;
              background-image: url('{{ user.photoURL }}');
              background-size: cover;
              background-position: center;
            "
          ></div>
          <div>
            <small class="d-block fw-medium">
              {{ user.displayName }}
            </small>
            <!--
            @if (company) {
            <small class="d-block text-muted">
              {{ company.name }}
            </small>
            }
            -->
          </div>
        </div>
      </div>
    </div>
    
    <!-- Second row - buttons.
         Non e' una .row di Bootstrap con due .col-6: li' lo stacco fra i due
         pulsanti e' il gutter (24px) e non si puo' stringere senza toccarlo
         per tutta l'app. Qui e' un flex con il proprio gap, e i due pulsanti
         si dividono la larghezza in parti uguali (vedi .side-user-actions). -->
    <div class="side-user-actions mb-2">
      <button
        mat-stroked-button
        class="izy-button-ghost custom-button-border d-flex align-items-center justify-content-center gap-0"
        style="min-height: 36px; white-space: nowrap;"
        [routerLink]="['/', organizationId, 'companies']"
        (click)="clickOnVoiceButton()">
        <mat-icon class="flex-shrink-0" style="font-size: 18px; width: 18px; height: 18px;">account_circle</mat-icon>
        <span class="flex-shrink-0" style="font-size: 0.875rem;">Accesso</span>
      </button>

      <button
        mat-stroked-button
        class="izy-button-ghost custom-button-border d-flex align-items-center justify-content-center gap-1"
        style="min-height: 36px; white-space: nowrap;"
        [routerLink]="['/', 'auth', 'logout']"
        (click)="clickOnVoiceButton()">
        <mat-icon class="flex-shrink-0" style="font-size: 18px; width: 18px; height: 18px;">logout</mat-icon>
        <span class="flex-shrink-0" style="font-size: 0.875rem;">Logout</span>
      </button>
    </div>
  </div>
  }
  <!-- <mat-list>
<div mat-subheader>Folders</div>
<mat-list-item (click)="clickOnVoiceButton()" *ngFor="let folder of folders">
  <mat-icon matListItemIcon>folder</mat-icon>
  <div matListItemTitle>{{folder.name}}</div>
  <div matListItemLine>{{folder.updated | date}}</div>
</mat-list-item>
<div mat-subheader>Notes</div>
<mat-list-item (click)="clickOnVoiceButton()" *ngFor="let note of notes">
  <mat-icon matListItemIcon>note</mat-icon>
  <div matListItemTitle>{{note.name}}</div>
  <div matListItemLine>{{note.updated | date}}</div>
</mat-list-item>
</mat-list> -->
</div>
